import moment from "moment";
import { LoginResponse } from "../models";
import { utils } from "../utils";

class Logger {

    saveLog = (message) => {
        // console.log(message);
        if (utils.isElectronBuild()) {
            window.myAPI.savAppLogs(message);
        }
    };

    getInternetStatus = (): string => {
        const isOnline = navigator.onLine ? "Online" : "Offline";
        const connection = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
        const effectiveType = connection?.effectiveType ?? "Unknown";

        let speedLabel = "Unknown";

        if (!navigator.onLine) {
            speedLabel = "Offline";
        } else {
            switch (effectiveType) {
                case "4g":
                    speedLabel = "Fast";
                    break;
                case "3g":
                    speedLabel = "Moderate";
                    break;
                case "2g":
                    speedLabel = "Slow";
                    break;
                case "slow-2g":
                    speedLabel = "Very Slow";
                    break;
                default:
                    speedLabel = "Very Slow";
                    break;
            }
        }

        return `Status: ${isOnline}, Effective Type: ${effectiveType} (${speedLabel})`;
    };

    isElectronAndRelevantScreen = () => {
        return utils.isElectronBuild() && (
            utils.isAnyChatPanelActive()
        );
    };

    log = (message: any, ...optionalParams: any[]) => {
        
        if (process.env.REACT_APP_CONSOLE_LOGS == "true") {
            let userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
            let userName = ""
            let currentData = new Date();

            if (userData?.userLoginData != null) {
                userName = userData?.userLoginData?.username
            }

            // console.log(`[${moment().format("h:mm:ss DD/MM/YYYY")}] ${message}`, optionalParams.length > 0 && optionalParams,);
            // console.log(`\n----------------------Chat Server Logs-------------------------------\nDate: ${currentData} \nUser Name:${userName} \nInternet: ${this.getInternetStatus()} (No.Of.Chats: ${utils.getRunningChats()}) WindowState: ${utils.getAppVisibility()}  \nPanel Type: ${this.getPanelName()} \nError Details: ${message}`)

            if (this.isElectronAndRelevantScreen()) {
                const errorText = [
                    "\n----------------------Chat Server Logs-------------------------------",
                    `Date: ${currentData}`,
                    `User Name: ${userName}`,
                    `Internet: ${this.getInternetStatus()} (No.Of.Chats: ${utils.getRunningChats()})`,
                    `WindowState: ${utils.getAppVisibility()}`,
                    `Panel Type: ${utils.getPanelName()}`,
                    `Error Details: ${message}`
                ].join(" \n");
                // console.log(errorText)

                window?.myAPI?.savAppLogs(errorText);
            }
        }
    };

}

var logger = new Logger();

export { logger };
